import { Box, Button } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useNavigationHistory } from './useNavigationHistory';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useNavigate } from 'react-router-dom';
export const TopbarNavigation = () => {
  const size = '30px';
  const fontSize = '18px';

  const navigate = useNavigate();

  const { goBack } = useNavigationHistory();
  const refresh = () => navigate(0);

  return (
    <Box className="flex gap-1 items-center">
      <Button
        className=" opacity-70"
        sx={{
          padding: '0px',
          minWidth: '0px',
          width: size,
          height: size,
          justifyContent: 'center',
          display: 'flex',
        }}
        onClick={goBack}
      >
        <ArrowBackIosNewIcon sx={{ fontSize }} />
      </Button>
      <Button
        className=" opacity-70"
        sx={{
          padding: '0px',
          minWidth: '0px',
          width: size,
          height: size,
          justifyContent: 'center',
          display: 'flex',
        }}
        onClick={refresh}
      >
        <RefreshIcon sx={{ fontSize }} />
      </Button>
    </Box>
  );
};
